/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="app.common.services.module.ts" />
/// <reference path="globalsettingsservice.ts" />

module App.Common.Services {
	'use strict';

	export class LogService {

		public static $inject = ['$log', 'app.common.services.globalSettingsService'];
		constructor(
			private $log: angular.ILogService,
			private globalSettings: Services.GlobalSettingsService) { }

		public log(...args: any[]) {
			this.$log.log.apply(this, args);
		}

		public info(...args: any[]) {
			this.$log.info.apply(this, args);
		}

		public warn(...args: any[]) {
			this.$log.warn.apply(this, args);
		}

		public error(...args: any[]) {
			this.$log.error.apply(this, args);
		}

		public debug(...args: any[]) {
			this.$log.debug.apply(this, args);
		}

		public debugVerbose(...args: any[]) {
			if (this.globalSettings.showVerboseDebugMessages) {
				this.$log.debug.apply(this, args);
			}
		}

	}

	angular
		.module('app.common.services')
		.service('app.common.services.logService', LogService);
}